// extracted by mini-css-extract-plugin
export default {"ContainerPreSolarsystem":"Presolarsystem_ContainerPreSolarsystem__bdIPo","Separator4":"Presolarsystem_Separator4__hcFMf"};